import { createAuthClient } from 'better-auth/react'
import { emailOTPClient } from 'better-auth/client/plugins'

// Dev: empty baseURL → same origin (Vite proxies /api → :3002). Prod: set VITE_API_URL.
const baseURL = import.meta.env.VITE_API_URL || ''

export const authClient = createAuthClient({
  baseURL: baseURL || undefined,
  plugins: [emailOTPClient()],
})

export type AuthUser = {
  id: string
  email: string
  name: string
  emailVerified: boolean
  image?: string | null
  createdAt: Date
  updatedAt: Date
}
